export default "__VITE_ASSET__B6kDyn3E__"